import rand from "@/utils/rand";
import {AwsService} from "@/simulation/AwsService";
import {Lambda} from "@/simulation/Lambda";
import wait from "@/utils/wait";

class Request {
    id = rand();
    error = false;
}

export class ApiGateway implements AwsService {
    id = rand();
    name = 'API Gateway';
    private readonly targetLambda: Lambda;
    requests: Array<Request> = [];
    successes = 0;
    errors = 0;

    constructor(targetLambda: Lambda) {
        this.targetLambda = targetLambda;
    }

    invoke(): void {
        this.receiveRequest();
    }

    receiveRequest(): Promise<void> {
        const request = new Request;
        this.requests.push(request);

        const promise = new Promise<void>((resolve, reject) => {
            // Invoke lambda
            this.targetLambda.invokeSync()
                .then(resolve, reject);
        });

        promise.then(
            () => this.respondSuccess(request),
            () => this.respondError(request),
        );

        return promise;
    }

    private respond(request: Request) {
        const index = this.requests.indexOf(request);
        if (index > -1) {
            this.requests.splice(index, 1);
        }
    }

    private respondSuccess(request: Request) {
        this.successes++;
        this.respond(request);
    }

    private respondError(request: Request) {
        this.errors++;
        // Make the error visible for a little while
        request.error = true;
        wait(300)
            .then(() => this.respond(request));
    }

    reset() {
        this.requests = [];
        this.successes = 0;
        this.errors = 0;
    }

    outputs(): Array<AwsService> {
        return [
            this.targetLambda,
        ];
    }
}
